import { DEFAULT_TOTAL_RECORDS } from "utils/constants";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");

export const fetchEmployeeTargets = (
  page_no,
  filter,
  limit = DEFAULT_TOTAL_RECORDS,
) => {
  return axiosInstance.get(EndPoints.EMPLOYEE_TARGET.LIST, {
    params: {
      limit,
      page_no,
      ...filter,
    },
  });
};

export const fetchEmployeeTargetByEmployeeId = (employee_id) => {
  const url = EndPoints.EMPLOYEE_TARGET.BY_EMPLOYEE_ID + `/${employee_id}`;

  return axiosInstance.get(url);
};

export const createEmployeeTarget = (payload) => {
  return axiosInstance.post(EndPoints.EMPLOYEE_TARGET.CREATE, payload);
};

export const updateEmployeeTarget = (payload) => {
  return axiosInstance.put(EndPoints.EMPLOYEE_TARGET.UPDATE, payload);
};

export const deleteEmployeeTarget = (id) => {
  return axiosInstance.delete(EndPoints.EMPLOYEE_TARGET.DELETE, {
    params: { id },
  });
};

export const downloadCSV = () => {
  return axiosInstance.put(EndPoints.EMPLOYEE_TARGET.DOWNLOAD_CSV, {
    responseType: "blob",
  });
};
